import { render, staticRenderFns } from "./ReceiveItemAset.vue?vue&type=template&id=04de5143&"
import script from "./ReceiveItemAset.vue?vue&type=script&lang=js&"
export * from "./ReceiveItemAset.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveItemAset.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports